/* eslint-disable @typescript-eslint/no-explicit-any */
import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';
import { theme } from '@marriott/mi-ui-library-shop';
import { mediaQuery } from '../../utils/styles';

export const StyledCardArt = styled.div`
  .card-art-wrapper {
    &.align-center {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
    @media ${mediaQuery.mobileOnly} {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .credit-card-container {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: ${toRem(8)};

      .logo-image {
        height: ${toRem(130)};
        margin-bottom: ${toRem(16)};
        object-fit: contain;
      }
    }

    .text-block {
      display: flex;
      flex-direction: column;
      text-align: left;
      @media ${mediaQuery.mobileOnly} {
        text-align: center;
      }
    }
    .text-block div {
      color: ${theme.color['dark-gray-13']};
    }
    .text-block h2 {
      @media ${mediaQuery.mobileOnly} {
        font-size: ${toRem(25)};
      }
    }
  }

  /* keep the TnC centering utility near the component */
  .tnc-links__wrapper--center-mobile {
    @media ${mediaQuery.mobileOnly} {
      justify-content: center;
    }
  }
`;
